// ----------------------------------------------------
// src/Routes/AppRoutes.jsx
// ----------------------------------------------------

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "../Pages/Home";
import About from "../Pages/About";
// import Product from "../Pages/Product";
import OurProduct from "../Components/OurProduct/OurProduct";
import Service from "../Pages/Service";
import Contact from "../Pages/Contact";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />

      {/* Other Pages */}
      <Route path="/about" element={<About />} />
      {/* <Route path="/product" element={<Product />} /> */}
      <Route path="/product" element={<OurProduct />} />
      <Route path="/service" element={<Service />} />
      <Route path="/contact" element={<Contact />} />

      {/* Redirect Random URL */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;